// FDB drug-drug interaction severity codes mapped to clinician-facing labels.
export const SEVERITY_LABELS: Record<string, string> = {
  '1': 'Contraindicated',
  '2': 'Severe',
  '3': 'Moderate',
  '9': 'Undetermined',
};
export const SEVERITY_ORDER = ['1', '2', '3', '9'];
// Soft background + strong text, matching the app's status-pill idiom.
export const SEVERITY_BADGE_CLASSES: Record<string, string> = {
  '1': 'bg-red-100 text-red-800 border-red-300',
  '2': 'bg-orange-100 text-orange-800 border-orange-300',
  '3': 'bg-amber-100 text-amber-800 border-amber-300',
  '9': 'bg-slate-100 text-slate-700 border-slate-300',
};
export const ALLERGY_BADGE_CLASSES = 'bg-red-100 text-red-800 border-red-300';
